import React, {Component} from 'react'

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { loadCollection, loadedCollection } from '../reducers/actions';
import { Swipeable, defineSwipe } from 'react-touch';
import { Link } from 'react-router-dom'
import { objectToArray } from '../helper'

class Voucher extends Component {
    constructor(props) {
        super(props)
        this.state = {activeIndex:0}
    }

    next() {
        const trainingTypes = this.props.trainingTypes || [];

        if (this.state.activeIndex < trainingTypes.length-1) {
            this.setState({activeIndex: this.state.activeIndex+1})
        }
    }

    prev() {
        if (this.state.activeIndex > 0) {        
            this.setState({activeIndex: this.state.activeIndex-1})
        }
    }

    render() {
        const props = this.props
        const activeIndex = this.state.activeIndex;

        if (!this.props.trainingTypes) return <div />;

        const offset = (activeIndex * -390);

        const sliderStyles = {
            transform: 'translateX('+offset+'px)'
        }

        const swipe = defineSwipe({swipeDistance: 50});

        const vehicleTypeId = this.props.vehicleTypeId;

        const trainingTypes = this.props.trainingTypes


        return (
            <div className="offer-slider-container">
                {activeIndex > 0 && (
                <button className="offer-slider-container-left" onClick={() => this.prev()}>
                    <span className="sr-only">Links</span>
                </button>
                )}
                {activeIndex < trainingTypes.length-1 && (
                <button className="offer-slider-container-right" onClick={() => this.next()}>
                    <span className="sr-only">Rechts</span>
                </button>
                )}

                <Swipeable config={swipe} onSwipeLeft={() => this.next()} onSwipeRight={() => this.prev()}>
                <div className="offer-slider offer-slider--voucher" style={sliderStyles}>
                    {trainingTypes.filter(t => t.shopWeekdayPrice && t.shopWeekendPrice).map((trainingType,ei) => {
                        const classNames = ["offer-slide"]
                        const linkTo = "/shop/" + vehicleTypeId + "/" + trainingType.id
                        let buttonClassName = "white-btn"


                        if (ei === this.state.activeIndex) {
                            classNames.push('active')
                            buttonClassName = "blue-btn"
                        }

                        return (
                            <article key={ei} className={classNames.join(' ')}>
                                <div className="offer-slide-content">
                                    <h1 className="offer-slide-name">{trainingType.name}</h1>
                                    <p className="offer-slide-description">{trainingType.shopDescription}</p>
                                    <span className="offer-slide-duration">{trainingType.shopDuration}</span>
                                    {trainingType.shopWeekdayPrice && (
                                    <div className="offer-slide-period">
                                        <span  className="offer-slide-period-price">{ parseInt(trainingType.shopWeekdayPrice) } €</span>
                                        <h2 className="offer-slide-period-title">Montag - Freitag</h2>
                                        <Link to={"/shop/gutschein/" + props.vehicleTypeId + "/" + trainingType.id + "/" + trainingType.shopWeekdayPrice} className={buttonClassName}>Jetzt buchen</Link>
                                    </div>
                                    )}
                                    {trainingType.shopWeekendPrice && (
                                    <div className="offer-slide-period">
                                        <span  className="offer-slide-period-price">{ parseInt(trainingType.shopWeekendPrice) } €</span>
                                        <h2 className="offer-slide-period-title">Sa., So. und Feiertage</h2>
                                        <Link to={"/shop/gutschein/" + props.vehicleTypeId + "/" + trainingType.id + "/" + trainingType.shopWeekendPrice} className={buttonClassName}>Jetzt buchen</Link>
                                    </div>
                                    )}
                                </div>
                            </article>
                        )
                    })}
                </div>
                </Swipeable>
            </div>
        )
    }
}

function mapStateToProps(state, props) {
    const vehicleTypeId = (props.settings && props.settings.id) || props.vehicleTypeId;
    return { 
        vehicleTypeId: vehicleTypeId,
        trainingTypes: objectToArray(state.shop.trainingTypes).filter(t => t.vehicleTypeId == vehicleTypeId).map((t) => {
            return {
                ...t,
                hasTrainings: state.shop.trainings.filter(tt => tt.trainingTypeId == t.id).length > 0
            }
        }),
        vehicleTypes: state.shop.vehicleTypes
    }
}

function mapDispatchToProps(dispatch) {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Voucher)


// WEBPACK FOOTER //
// ./src/components/VoucherSlider.js